import { render, staticRenderFns } from "./FullCalendar.vue?vue&type=template&id=498a7fe3"
import script from "./FullCalendar.vue?vue&type=script&lang=js"
export * from "./FullCalendar.vue?vue&type=script&lang=js"
import style0 from "./FullCalendar.vue?vue&type=style&index=0&id=498a7fe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports